import { apiRequest } from '../../api/client';

const unwrap = <T,>(p: Promise<{ data: T }>) => p.then((envelope) => envelope.data);

/** Kiểu khai ở `ConfigKeys` bên backend — quyết định cách hiện ô nhập */
export type ConfigValueType = 'Integer' | 'Decimal' | 'Boolean';

export interface SystemConfig {
  key: string;
  value: number;
  defaultValue: number;
  /** `false` nghĩa là đang chạy bằng mặc định, chưa ai đổi */
  isOverridden: boolean;
  type: ConfigValueType;
  minimum: number;
  maximum: number;
  unit: string;
  description: string;
  isBranchOverridable: boolean;
  reason: string | null;
  updatedAt: string | null;
}

export const configKeys = {
  all: ['configs'] as const,
};

export const configApi = {
  list: () => unwrap(apiRequest<SystemConfig[]>('/admin/configs')),

  set: (key: string, value: number, reason: string) =>
    unwrap(
      apiRequest<SystemConfig>(`/admin/configs/${encodeURIComponent(key)}`, {
        method: 'PUT',
        body: { value, reason },
      }),
    ),

  reset: (key: string, reason: string) =>
    unwrap(
      apiRequest<SystemConfig>(`/admin/configs/${encodeURIComponent(key)}/reset`, {
        method: 'POST',
        body: { reason },
      }),
    ),
};

/**
 * Gom theo tiền tố của khóa (`Otp:LifetimeMinutes` → `Otp`).
 *
 * Một bảng phẳng mười mấy dòng tên kỹ thuật thì người vận hành phải đọc hết mới
 * tìm ra thứ cần sửa. Nhóm bằng chính tiền tố thay vì bảng ánh xạ riêng: thêm khóa
 * mới bên backend là màn này tự có nhóm, không phải nhớ sửa thêm chỗ nào.
 */
export const GROUP_LABELS: Record<string, string> = {
  Auth: 'Đăng nhập & mật khẩu',
  BillScan: 'Quét hóa đơn',
  Content: 'Nội dung & băng-rôn',
  Idempotency: 'Chống gửi trùng',
  Otp: 'Mã xác thực OTP',
  Qr: 'Mã QR thành viên',
};

export function groupOf(key: string): string {
  return key.split(':')[0];
}
